module.exports = __webpack_public_path__ + "static/img/idcard.a0e3fe32.jpg";